<template>
  <div class="container">
    <HeaderComponent></HeaderComponent>
    <main>
      <div class="wpb_wrapper">
        <div class="wpb_text_column wpb_content_element imprensa-assessoria">
          <div class="title">
            <h2>{{ translate.title }}</h2>
          </div>
        </div>
        <div class="row">
          <p><span v-html="getResult"></span></p>
        </div>
        <div class="row">
          <div class="col text-left count-result" v-if="reseller">
            <p class="d-inline"><span class="number">1 - </span> {{ translate.result }}</p>
          </div>
        </div>
        <div class="reseller" v-if="reseller">
          <div class="row wpsl-store-location">
            <div class="col text-left">
              <h2 class="title_reseller">{{ reseller.name }}</h2>
            </div>
          </div>
          <div class="row align-items-end">
            <div class="col address_reseller">
              <div v-if="reseller.address.address">
                  ENDEREÇO: {{ reseller.address.address }}
              </div>
              <div v-if="reseller.address.zipcode">
                  CEP: {{ reseller.address.zipcode }}
              </div>
              <div v-if="reseller.site">
                  SITE: {{ reseller.site }}
              </div>
              <div v-if="reseller.phone">
                  TELEFONE: {{ reseller.phone }}
              </div>
              <div v-if="reseller.cellphone">
                  CELULAR: {{ reseller.cellphone }}
              </div>
              <div v-if="reseller.email">
                  E-EMAIL: {{ reseller.email }}
              </div>
              <div v-if="reseller.social_medias.facebook">
                  FACEBOOK: {{ reseller.social_medias.facebook }}
              </div>
              <div>
                CIDADE: {{ reseller.address.city }}
              </div>
              <div v-if="reseller.distance">
                DISTÂNCIA: {{ (reseller.distance) ? parseInt(reseller.distance) + 'km' : '' }}
              </div>
              <div v-if="reseller.social_medias.instagram">
                INSTAGRAM: {{ reseller.social_medias.instagram }}
              </div>
            </div>
            <div class="col" v-if="reseller">
            <div class="buttons no-print" >
              <button type="button" @click="print()" class="btn-impressao btn">
                <span>{{ translate.print }}</span>
              </button>
              <button type="button" @click="send()" class="btn-email btn">
                <span>{{ translate.send }}</span>
              </button>
            </div>
          </div>
          </div>
          <div class="row">
            <div class="col">
              <google-map :lat="reseller.lat" :lng="reseller.lng"/>
            </div>
          </div>
        </div>
        <div class="footer">
          <div class="row">
            <div class="col-2 text-left buttons">
              <router-link class="btn back" :to="{ name:'form', params: { language }}"><img width="15px" src="../assets/arrow.png" />{{ translate.button }}</router-link>
            </div>
          </div>
        </div>
        <div class="position-fixed alert justify-end">
          <div :class="['col-12 form-group', (sent) ? 'valid' : 'invalid', (message !== null) ? 'show': '']" >
            <div class="feedback message">{{ message }}</div>
          </div>
        </div>
      </div>
    </main>
    <FooterComponent></FooterComponent>
  </div>
</template>

<script>
import HeaderComponent from './Header.vue';
import FooterComponent from './Footer.vue';
import { mapActions } from 'vuex'
import Events from '../shared/events';
import { resultEn, resultIt, resultEs, resultPt } from '../lang';
import GoogleMap from '../shared/GoogleMap';
import LeadService from "../service/lead";
import { lead } from './mockup';

export default {
  name: 'page-result',
  components: {
    HeaderComponent,
    FooterComponent,
    GoogleMap,
  },
  computed: {
    lead() {
      if (this.$store.state.lead) {
        return this.$store.state.lead;
      }
      return { ...lead };
    },
    reseller() {
      if (this.$store.state.reseller) {
        return this.$store.state.reseller;
      }
      return false;
    },
    isEngineeringLead() {
      return !!this.$store.state.isEngineeringLead;
    },
    getResult() {
      if (this.isEngineeringLead) {
        return this.translate.engineering_results;
      }
      if (this.reseller) {
        return this.translate.thanks.replace('{zipcode}', this.zipcode);
      }
      return this.translate.no_results;
    },
  },
  data() {
    return {
      sent: true,
      language: this.$route.params.language,
      translate: { ...resultPt },
      message: null,
      zipcode: '',
    };
  },
  methods: {
    ...mapActions([
      'setLead',
    ]),
    checkLanguage() {
      this.language = this.$route.params.language;
      if (this.language) {
        switch (this.language) {
          case 'en':
            return this.setLanguage(resultEn);
          case 'es':
            return this.setLanguage(resultEs);
          case 'it':
            return this.setLanguage(resultIt);
          case 'pt':
          default:
            return this.setLanguage(resultPt);
        }
      }
    },
    closeMessage() {
      setTimeout(() => {
        this.message = null;
      }, 2500);
    },
    print() {
      window.print();
    },
    setLanguage(language) {
      this.translate = language;
    },
    send() {
      LeadService.send(this.lead.id)
        .then(response => {
          this.sent = response.sent;
          this.closeMessage();
        });
    },
  },
  mounted() {
    this.checkLanguage();
    Events.$on('success', () => {
      this.zipcode = (this.lead) ? this.lead.zipcode : '';
    });
    Events.$on('change_translate', () => {
      this.checkLanguage();
    });
  },
}
</script>

<style lang="scss" scoped>

@media print {
  * { box-sizing: border-box; }
  .container {
    width: 1002px;
    margin: 0 auto;
  }
  .no-print, .no-print * {
    display: none !important;
  }
}

.container main {
  .wpb_wrapper {
    margin-top: 60px;
    max-width: 66.664%;
    padding: 0 16px;
    width: 100%;
    position: relative;
    .title {
      position: relative;
      h2 {
        font-weight: normal;
        &:before {
          content: "";
          display: block;
          border-top: 1px solid #ae936a;
          width: 69px;
          position: absolute;
          left: calc(-69px - 16px);
          top: 15px;
        }
      }
      p {
        margin: 50px 0;
        font-size: 16px;
      }
    }
  }
}
.reseller {
  padding-bottom: 20px;
  margin-bottom: 20px;
  border-bottom: 1px dotted #ccc;
  width: 100%;
}
.address_reseller {
  text-align: left;
  div {
    line-height: 25px;

  }
}
.row.align-items-end {
  display: flex;
  align-items: flex-end;
  margin-bottom: 40px;
}
.d-inline {
  display: inline-block;
}
.buttons {
  display: flex;
  justify-content: space-around;
  text-align: center;
  .btn {
    flex: 0 1 250px;
    cursor: pointer;
    background: #ae936a;
    color: #fff;
    font-size: 14px;
    text-transform: uppercase;
    text-decoration: none;
    padding: 0.85rem;
    border: 0;
    border-radius: 40px;
    width: 100%;
    text-align: center;
    position: relative;
    img {
      position: absolute;
      top: 50%;
      left: 10px;
      transform:  translateY(-50%);
    }
  }
}
.text-left {
  text-align: left;
}
.text-uppercase {
  text-transform: uppercase;
}
.botao_encontrar a {
  width: 245px;
  display: flex;
  align-items: middle;
  justify-content: center;
  background: #fff;
  padding: 5px 25px;
  border: 2px solid #000;
  cursor: pointer;
  color: #000;
  margin-top: 0;
  height: 45px;
  line-height: 35px;
  text-decoration: none;
  font-size: 12px;
  span {
    margin: 0;
    display: inline-block;
  }
  &:hover {
    background-color: #000;
    color: #fff;
    text-decoration: none;
    img {
      margin-left: 20px;
    }
    .up {
      display: none;
    }
  }
}
.title_reseller {
  text-transform: uppercase;
  font-size: 18px;
  margin-top: 30px;
  margin-bottom: 30px;
  a {
    color: #000;
    text-decoration: none;
  }
}
.bloco_onde_encontrar {
  text-align: left;
  span {
    display: inline-block;
    margin-bottom: 10px;
    font-size: 14px;
  }
}
.count-result {
  display: flex;
  align-items: center;
  font-weight: 700;
  .number {
    font-size: 22px;
  }
}
.btn {
  position: relative;
  span {
    position: relative;
    display: inline-block;
    bottom: 0;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 2px;
    text-align: center;
  }
}
.line {
  width: 45px;
  height: 5px;
  background: #000;
}
.row {
  display: flex;
  align-items: flex-start;
}
.col {
  flex-basis: 0;
  -ms-flex-positive: 1;
  flex-grow: 1;
  max-width: 100%;
  &-1 {
    width: 245px;
    max-width: 245px;
  }
}
.title {
  width: 100%;
  text-align: left;
}
.footer {
  margin-top: 30px;
  width: 100%;
}
.creat-list {
  float: right;
  list-style: none;
  padding-left: 0;
  text-align: center;
  li {
    float: left;
    font-size: 10px;
    color: #000;
    margin-right: 10px;
    line-height: 10px;
    text-transform: uppercase;
    font-family: Muli,sans-serif;
    a {
      line-height: 12px;
      padding-left: 55px;
      position: relative;
      letter-spacing: 2px;
      text-decoration: none;
      color: #000;
      &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 0;
        width: 40px;
        height: 1px;
        background: #000;
        transition: all .2s linear;
      }
    }
    &:hover{
      a::before {
        transform: rotate(45deg);
      }
    }
  }
}
.back {
  font-size: 14px;
  color: #fff;
  background-color: #000;
  text-decoration: none;
  display: inline-block;
}

.position-fixed {
  position: fixed;
  bottom: 20px;
  width: 50%;
  margin: auto;
  left: 25%;
}
.form-group {
    width: 100%;
    flex: 1 1 100%;
    max-width: 100%;
    padding: 0 10px;
    text-align: left;
    .feedback {
        display: none;
        background: #fff;
        border: 2px solid #47e947!important;
    }
    &.show {
        .feedback {
            display: block;
        }
    }
    &.invalid {
        .feedback {
            border: 2px solid red!important;
        }
    }
    .message {
        margin-top: 20px;
        text-transform: uppercase;
        color: #000;
        text-align: center;
        padding: 10px!important;
    }
}

@media screen and (max-width: 1300px) {
  .container main :deep(.wpb_wrapper) {
    max-width: 100%!important;
  }
}

@media screen and (max-width: 970px) {
  .container main .wpb_wrapper {
    .row {
      .buttons {
        width: 100%;
        margin-top: 20px;
        padding-right: 0;
        justify-content: space-between;
        .btn {
          flex: 0 1 180px;
        }
      }
      &.align-items-end {
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        .col {
          width: 100%;
        }
      }
    }
  }
}

</style>